// files from backend
const store = require('../../store');
export const getFileUrl = (file, previewPreferFlag = false) => {
    if (!file) {
        return ''
    }
    if (!file?._id) {
        if (file instanceof File || file instanceof Blob) {
            return URL.createObjectURL(file);
        }

        return '';
    }
    if (file?.is_local) {
        if (previewPreferFlag && file.preview_file) {
            return `${store.default.getters['settings/BACKEND_URL']}/${file?.preview_file}` 
        }
        return `${store.default.getters['settings/BACKEND_URL']}/${file?.path}`
    } else {
        if (previewPreferFlag && file.preview_file) {
            return file?.preview_file
        }
        return file?.path || ''
    }
    
}
